/*eslint no-unused-vars:0*/
/*eslint no-undef:0*/
/**
 * This class implements the scroll animation for the Refill Jar,
 * Candle Holders, Easter Egg Gift Sets and Banner Video (Advent).
 *
 * Jira tickets:
 * https://rituals.atlassian.net/browse/DL-14218
 * https://rituals.atlassian.net/browse/DL-18446
 * https://rituals.atlassian.net/browse/DL-20750
 */
'use strict';

const {Power4} = require('gsap');
const ScrollMagic = require('scrollmagic');
const gsap = require('gsap').gsap;
const ScrollMagicPluginGsap = require('scrollmagic-plugin-gsap');
const isSmallView = require('./modules/helpers/isSmallView');
const isSmallTabletView = require('./modules/helpers/isSmallTabletView');
const isInViewport = require('./modules/helpers/isInViewport');
const isDesktopOrTabletLandscapeView = require('./modules/helpers/isDesktopOrTabletLandscapeView');
const {disableScroll} = require('./modules/helpers/scroll');

const scrollMagicEl = '.js-scroll-magic-trigger';
const scrollEl = '.js-scroll-animation-wrapper:not(.initialized), .js-refill-jar-wrapper:not(.initialized)';
ScrollMagicPluginGsap.ScrollMagicPluginGsap(ScrollMagic, gsap);

/**
 * Initializes the animations. These can be
 * - Refill Jar animation: 'refill-jar' (default)
 * - Candle Holder animation: 'candle-holder'
 * - Easter Egg Gift Set animation: 'easter-egg-gift-set'
 * - Banner Video (Advent): 'banner-video-animation'
 */
const initAnimations = () => {

    $(scrollEl).each((i, el) => {
        const type = $(el).data('animation-type') || 'refill-jar';

        switch (type) {
            case 'candle-holder':
                prepareImages(el);
                if (!isSmallView()) {
                    initCandleHolderAnimation(el);
                }
                break;

            case 'easter-egg-gift-set':
                prepareImages(el);
                initEasterEggGiftSetAnimation(el);
                break;

            case 'banner-video-animation':
                if (!$('.js-grid-wrap').length) {
                    initBannerVideoAnimation(el);
                } else if ($('.js-grid-wrap').length && $('.js-grid-wrap').hasClass('grid-initialized')){
                    initBannerVideoAnimation(el);
                }
                break;

            case 'gift-reveal-animation':
                initGiftRevealAnimation(el);
                break;

            case 'advent-animation-block':
                if (!isSmallTabletView()) {
                    adventAnimationBlock(el);
                }
                break;

            case 'advent-ar-block-an':
                if (!isSmallTabletView()) {
                    adventArBlock(el);
                }
                break;

            case 'advent-usp-block':
                if (!isSmallView()) {
                    adventUspBlock(el);
                }
                break;

            case 'advent-overview-block':
                if (isDesktopOrTabletLandscapeView()) {
                    adventOverviewBlock(el);
                }
                break;

            case 'advent-png-sequence':
                adventPNGSequence(el);
                break;

            case 'advent-hero-block':
                adventHeroBlock(el);
                break;

            case 'advent-text-animation-block':
                adventTextAnimation(el);
                break;

            default:
                initRefillJarAnimation(el);
        }
    });
};


const initGiftRevealAnimation = (el) => {
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];
    const $ribbon1 = $('.js-ribbon-1');
    const controller = new ScrollMagic.Controller();
    const tween = gsap.timeline()
        .add([
            gsap.fromTo($ribbon1, 1, {x: 0, y: 0}, {y: 100, ease: 'none'})
        ]);

    const scene = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: 100,
        offset: 0
    })
        .setTween(tween)
        .addTo(controller);

    $(el).addClass('initialized');
};

/**
 * Initialises the Refill Jar animation
 * @param {DOM Object} el The element to initialise
 */
const initRefillJarAnimation = (el) => {
    const $jarLidEl = $('.js-refill-jar-lid', el);
    const $jarRefilEl = $('.js-refill-jar-content', el);
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];

    const hasTextBlocks = el.parentNode.classList.contains('image-holder-column');
    const jarToY = isSmallView() ? -130 : -230;
    const refillToY = isSmallView() ? -80 : -160;
    const duration = isSmallView() ? '75%' : '65%';
    const offset = -150;

    const controller = new ScrollMagic.Controller();
    const tween = gsap.timeline()
        .add([
            gsap.fromTo($jarLidEl, 1, {x: 0, y: 0}, {y: jarToY, ease: 'none'}),
            gsap.fromTo($jarRefilEl, 1, {x: 0, y: 0}, {y: refillToY, ease: 'none'})
        ]);

    const scene = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: duration,
        offset: offset
    })
        .setTween(tween)
        .addTo(controller);

    $(el).addClass('initialized');

    if (hasTextBlocks) {
        const textBlocks = el.closest('.inner-wrapper').querySelectorAll('.text-holder-column > div');
        textBlocks.forEach((el) => {
            textBlockObserver.observe(el);
        });
    }
};

const textBlockObserver = new IntersectionObserver((textBlocks) => {
    for (const textBlock of textBlocks) {
        if (textBlock.isIntersecting) {
            const el = textBlock.target;
            el.classList.add('text-inner--anim');
            textBlockObserver.unobserve(el);
        }
    }
}, {
    threshold: [0.4]
});

const adventAnimationBlock = (el) => {
    const $headline = $('.headline', el);
    const $specText = $('.specification-text');
    const $specBox = $('.specification-box');
    const adventImage = ('#js-advent-pin-img');
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];
    const duration = '65%';
    const offset = 150;

    const controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onCenter'
        }
    });

    const controller2 = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onLeave'
        }
    });

    const controller3 = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onLeave'
        }
    });

    const closingTween = gsap.timeline()
        .add([
            gsap.fromTo($headline, 1, {opacity: 1}, {opacity: 0, ease: 'none'}),
            gsap.fromTo($specText, 0.6, {opacity: 1}, {opacity: 0, delay: 0.5, ease: 'none'}),
            gsap.fromTo($specBox, 0.6, {opacity: 1}, {opacity: 0, delay: 1, ease: 'none'}),
            gsap.fromTo($('.item', el), 1, {opacity: 1}, {opacity: 0.3, delay: 1.5, ease: 'none'})
        ]);

    const tween = gsap.timeline()
        .add([
            gsap.fromTo($headline, 0.5, {opacity: 0}, {opacity: 1, ease: 'none'}),
            gsap.fromTo($specText, 0.5, {opacity: 0}, {opacity: 1, delay: 0.25, ease: 'none'}),
            gsap.fromTo($specBox, 0.3, {opacity: 0}, {opacity: 1, delay: 0.35, ease: 'none'})
        ]);

    const scene = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: duration,
        offset: 0
    })
        .setTween(tween)
        .addTo(controller);

    const scene2 = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: duration,
        offset: offset
    })
        .setTween(closingTween)
        .addTo(controller2);

    const scene3 = new ScrollMagic.Scene({
        triggerElement: '.scroll-magic-trigger2',
        duration: '100%',
        offset: 0
    })
        .setPin(adventImage)
        .addTo(controller3);

    $(el).addClass('initialized');
};

const adventArBlock = (el) => {
    const $headline = $('.headline', el);
    const $arText = $('.advent-ar-text');
    const $arButton = $('.js-advent-ar-button');
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];
    const duration = '65%';
    const offset = 0;

    const controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onCenter'
        }
    });

    const controller2 = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onLeave'
        }
    });

    const closingTween = gsap.timeline()
        .add([
            gsap.fromTo($headline, 1, {opacity: 1}, {opacity: 0, ease: 'none'}),
            gsap.fromTo($arButton, 1, {opacity: 1}, {opacity: 0, delay: 0.2, ease: 'none'}),
            gsap.fromTo($arText, 1, {opacity: 1}, {opacity: 0, delay: 0.5, ease: 'none'}),
            gsap.fromTo($('.advent-ar-icon'), 1, {opacity: 1, transform: 'rotate(0)'}, {opacity: 1, transform: 'rotate(90deg)', delay: 0.5, ease: 'none'}),
            gsap.fromTo($('.advent-ar-icon'), 1, {opacity: 1, transform: 'scale(1)'}, {opacity: 1, transform: 'scale(0)', delay: 0.5, ease: 'none'}),
            gsap.fromTo($('.item', el), 1, {opacity: 1}, {opacity: 0, delay: 2, ease: 'none'})
        ]);

    const tween = gsap.timeline()
        .add([
            gsap.fromTo($headline, 0.5, {opacity: 0}, {opacity: 1, delay: 0.5, ease: 'none'}),
            gsap.fromTo($arButton, 0.5, {opacity: 0}, {opacity: 1, delay: 0.7, ease: 'none'}),
            gsap.fromTo($arText, 0.3, {opacity: 0}, {opacity: 1, delay: 0.9, ease: 'none'}),
            gsap.fromTo($('.advent-ar-icon'), 1, {opacity: 0, transform: 'rotate(-90deg)'}, {opacity: 1, transform: 'rotate(0)', delay: 0.5, ease: 'none'}),
            gsap.fromTo($('.advent-ar-icon'), 1, {opacity: 0, transform: 'scale(0)'}, {opacity: 1, transform: 'scale(1)', delay: 0.5, ease: 'none'})
        ]);

    const scene = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: duration,
        offset: offset
    })
        .setTween(tween)
        .addTo(controller);

    const scene2 = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: duration,
        offset: 150
    })
        .setTween(closingTween)
        .addTo(controller2);

    $(el).addClass('initialized');
};

const adventUspBlock = (el) => {
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];
    const $colWrapper = $('.concept-highlight-block-advent');

    const controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onEnter'
        }
    });

    const controller2 = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onLeave'
        }
    });

    const closingTween = gsap.timeline()
        .add([
            gsap.fromTo($colWrapper, 0.5, {opacity: 1}, {opacity: 0, delay: 0.2, ease: 'none'})
        ]);

    const tween = gsap.timeline()
        .add([
            gsap.fromTo($colWrapper, 0.5, {opacity: 0}, {opacity: 1, delay: 0.2, ease: 'none'})
        ]);

    const scene = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: '55%'
    })
        .setTween(tween)
        .addTo(controller);

    const scene2 = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: '55%',
        offset: -400
    })
        .setTween(closingTween)
        .addTo(controller2);

    $(el).addClass('initialized');
};

const adventOverviewBlock = (el) => {
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];
    const scrollVideo = ('.js-background-video', el);

    const controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onCenter'
        }
    });

    const controller2 = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onLeave'
        }
    });

    const closingTween2 = gsap.timeline()
        .add([
            gsap.fromTo($('.calendar-overview-header', el), 1, {opacity: 1}, {opacity: 0, delay: 0.1, ease: 'none'}),
            gsap.fromTo($('.calendar-overview-subhead', el), 1, {opacity: 1}, {opacity: 0, delay: 0.3, ease: 'none'}),
            gsap.fromTo($('.calendar-overview-text', el), 1, {opacity: 1}, {opacity: 0, delay: 0.5, ease: 'none'}),
            gsap.fromTo($('.calender-overview-box', el), 1, {opacity: 1}, {opacity: 0, delay: 0.7, ease: 'none'}),
            gsap.fromTo($('.content-list-wrapper', el), 1, {opacity: 1}, {opacity: 0, delay: 1.1, ease: 'none'}),
            gsap.fromTo($('.calendar-overview-disclamer', el), 1, {opacity: 1}, {opacity: 0, delay: 1.2, ease: 'none'})
        ]);

    const closingTween3 = gsap.timeline()
        .add([
            gsap.fromTo($(scrollVideo), 1, {opacity: 1}, {opacity: 0, delay: 1.5, ease: 'none'})
        ]);

    const tween = gsap.timeline()
        .add([
            gsap.fromTo($('.calendar-overview-header', el), 1, {transform:'translateY(30px)'}, {transform:'translateY(0)', delay: 0.5, ease: Power4.easeOut}),
            gsap.fromTo($('.calendar-overview-header', el), 1, {opacity: 0}, {opacity: 1, delay: 0.3, ease: 'none'}),
            gsap.fromTo($('.calendar-overview-subhead', el), 1, {transform:'translateY(30px)'}, {transform:'translateY(0)', delay: 0.6, ease: Power4.easeOut}),
            gsap.fromTo($('.calendar-overview-subhead', el), 1, {opacity: 0}, {opacity: 1, delay: 0.5, ease: 'none'}),
            gsap.fromTo($('.calendar-overview-text', el), 1, {transform:'translateY(30px)'}, {transform:'translateY(0)', delay: 0.8, ease: Power4.easeOut}),
            gsap.fromTo($('.calendar-overview-text', el), 1, {opacity: 0}, {opacity: 1, delay: 0.7, ease: 'none'}),
            gsap.fromTo($('.calender-overview-box', el), 1, {transform:'translateY(30px)'}, {transform:'translateY(0)', delay: 1, ease: Power4.easeOut}),
            gsap.fromTo($('.calender-overview-box', el), 1, {opacity: 0}, {opacity: 1, delay: 0.9, ease: 'none'}),
            gsap.fromTo($('.content-list-wrapper', el), 1, {transform:'translateY(30px)'}, {transform:'translateY(0)', delay: 1, ease: Power4.easeOut}),
            gsap.fromTo($('.content-list-wrapper', el), 1, {opacity: 0}, {opacity: 1, delay: 1.2, ease: 'none'}),
            gsap.fromTo($('.calendar-overview-disclamer', el), 1, {transform:'translateY(30px)'}, {transform:'translateY(0)', delay: 1.3, ease: Power4.easeOut}),
            gsap.fromTo($('.calendar-overview-disclamer', el), 1, {opacity: 0}, {opacity: 1, delay: 1.4, ease: 'none'})
        ]);

    const scene = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: '55%'
    })
        .setTween(tween)
        .addTo(controller);

    if (!$(el).parents().hasClass('js-last-overview-tile')) {
        const closingTween = gsap.timeline()
            .add([
                gsap.fromTo($('.text-wrapper', el), 1, {transform:'translateY(0)'}, {transform:'translateY(-600px)', ease: 'none'})
            ]);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: $scrollMagicEl,
            duration: '100%',
            offset: 0
        })
            .setTween(closingTween)
            .setPin(scrollVideo)
            .addTo(controller2);
    }

    const scene3 = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: '55%',
        offset: 0
    })
        .setTween(closingTween2)
        .addTo(controller2);

    const scene4 = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: '55%',
        offset: 350
    })
        .setTween(closingTween3)
        .addTo(controller2);

    $(el).addClass('initialized');
};

const adventPNGSequence = (el) => {
    const canvas = document.querySelector('.js-christmas-scroll');
    const context = canvas.getContext('2d');

    const isDesktopView = () => {
        const desktopMinWidth = 1920;
        const vpWidth = $(window).width();

        return vpWidth >= desktopMinWidth;
    };

    const imageWidth = isDesktopView() ? 1920 : window.innerWidth;
    const imageHeight = isSmallView() ? 768 : window.innerHeight;
    const imageX = isSmallView() ? (window.innerWidth / 2) - (imageWidth / 2) : 0;
    const urlContainer = $('.js-advent-png-sequence');
    if (!urlContainer.length){
        return;
    }
    const pngSequenceURL = urlContainer.val();
    const imageDomain = 'https://rituals.scene7.com/is/image/rituals';

    if ($('.js-sticky-add-to-cart').length > 0) {
        $('.christmas-tree-wrapper').addClass('png-animation-cta');
    }

    if ($('.christmas-tree-wrapper').length > 0) {
        $('.christmas-tree-wrapper').addClass('christmas-tree-bottom-mask');
    }

    const controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 0,
            reverse: true
        }
    });

    const currentFrame = (index) => (
        `${pngSequenceURL}_${index.toString().padStart(3, '0')}?resMode=sharp2&wid=${imageWidth}`
    );

    function productFadeIn (productNum) {
        if (!$(productNum).hasClass('advent-product-reveal-fadein')) {
            $(productNum).addClass('advent-product-reveal-fadein');
        }
    }

    function productFadeOut (productNum) {
        if ($(productNum).hasClass('advent-product-reveal-fadein')) {
            $(productNum).removeClass('advent-product-reveal-fadein');
            $(productNum).removeClass('advent-toggle-animation');
        }
    }

    function popUpFadeOut (productNum) {
        if ($(productNum).hasClass('advent-product-reveal-open')) {
            $(productNum).removeClass('advent-product-reveal-open');
        }
    }

    const frameCount = 152;
    const images = [];

    if (navigator.connection && navigator.connection.effectiveType != '4g') {
        let i = 0;
        let y = 0;
        for (i = 0, y = 0; i <= frameCount; i++, y++) {
            if (i % 2 == 0) {
                images[y] = new Image();
                images[y].src = currentFrame(i);
            } else {
                y--;
            }
        }
    } else {
        for (let i = 0; i <= frameCount; i++) {
            images[i] = new Image();
            images[i].src = currentFrame(i);
        }
    }

    canvas.height = isDesktopView() ? 1080 : window.innerHeight;
    canvas.width = isDesktopView() ? 1920 : window.innerWidth;
    const img = new Image();
    img.src = currentFrame(0);
    img.onload = function() {
        context.drawImage(img, imageX, 0);
    };

    const obj = {curImg: 0};

    const tween = navigator.connection && navigator.connection.effectiveType != '4g' ?
        gsap.to(obj, 0.5, {
            curImg: images.length - 1,
            roundProps: 'curImg',
            onUpdate: function () {
                context.drawImage(images[obj.curImg], imageX, 0);
                if (obj.curImg >= 0 && obj.curImg <= 37) {
                    productFadeOut('.advent-product1');
                    popUpFadeOut('.advent-open-product1');
                } if (obj.curImg >= 38 && obj.curImg <= 46) {
                    productFadeIn('.advent-product1');
                } else if (obj.curImg >= 47 && obj.curImg <= 55) {
                    productFadeOut('.advent-product1');
                    popUpFadeOut('.advent-open-product1');
                } else if (obj.curImg >= 56 && obj.curImg <= 62) {
                    productFadeOut('.advent-product2');
                    popUpFadeOut('.advent-open-product2');
                } else if (obj.curImg >= 63 && obj.curImg <= 71) {
                    productFadeIn('.advent-product2');
                } else if (obj.curImg >= 72 && obj.curImg <= 80) {
                    productFadeOut('.advent-product2');
                    popUpFadeOut('.advent-open-product2');
                } else if (obj.curImg >= 81 && obj.curImg <= 89) {
                    productFadeOut('.advent-productfull');
                    popUpFadeOut('.advent-open-product-full');
                } else if (obj.curImg >= 90 && obj.curImg <= 95) {
                    productFadeIn('.advent-productfull');
                }
            }
        })
        : gsap.to(obj, 0.5, {
            curImg: images.length - 1,
            roundProps: 'curImg',
            onUpdate: function () {
                context.drawImage(images[obj.curImg], imageX, 0);
                if (obj.curImg >= 0 && obj.curImg <= 61) {
                    productFadeOut('.advent-product1');
                    popUpFadeOut('.advent-open-product1');
                } if (obj.curImg >= 62 && obj.curImg <= 69) {
                    productFadeIn('.advent-product1');
                } else if (obj.curImg >= 70 && obj.curImg <= 78) {
                    productFadeOut('.advent-product1');
                    popUpFadeOut('.advent-open-product1');
                } else if (obj.curImg >= 79 && obj.curImg <= 106) {
                    productFadeOut('.advent-product2');
                    popUpFadeOut('.advent-open-product2');
                } else if (obj.curImg >= 107 && obj.curImg <= 114) {
                    productFadeIn('.advent-product2');
                } else if (obj.curImg >= 115 && obj.curImg <= 130) {
                    productFadeOut('.advent-product2');
                    popUpFadeOut('.advent-open-product2');
                } else if (obj.curImg >= 131 && obj.curImg <= 147) {
                    productFadeOut('.advent-productfull');
                    popUpFadeOut('.advent-open-product-full');
                } else if (obj.curImg >= 148 && obj.curImg <= 152) {
                    productFadeIn('.advent-productfull');
                }
            }
        });

    $('.js-btn-flip-full').on('click', function(e) {
        disableScroll();
    });

    if (isSmallView()){
        $('.js-btn-flip').on('click', function(e) {
            const $product = $(this).closest('.advent-product-reveal');

            $('.js-advent-reveal-product').each(function(){
                const $currentBlock = $(this)[0].classList[1];

                if ($currentBlock === $product[0].classList[1]) {
                    if ($(this).hasClass('advent-product-reveal-open')) {
                        $(this).removeClass('advent-product-reveal-open');
                        $(`.advent-product-reveal.${$currentBlock}`).removeClass('advent-toggle-mobile-animation');
                        return;
                    } else {
                        $(this).addClass('advent-product-reveal-open');
                        $(`.advent-product-reveal.${$currentBlock}`).addClass('advent-toggle-mobile-animation');
                        return;
                    }
                }
            });
        });
    } else {
        $('.js-btn-flip').on('click', function(e) {
            e.stopPropagation();
            e.preventDefault();

            const $product = $(this).closest('.advent-product-reveal');
            $product.addClass('advent-toggle-animation');

            $('.js-advent-reveal-product').each(function(){
                const $currentBlock = $(this)[0].classList[1];

                if ($currentBlock === $product[0].classList[1]) {
                    $(this).addClass('advent-product-reveal-open');
                }
            });
        });
    }

    $('.js-advent-popup-close').on('click', function(e) {
        e.stopPropagation();
        e.preventDefault();

        const $product = $(this).closest('.js-advent-reveal-product')[0];
        $product.classList.remove('advent-product-reveal-open');

        $('.advent-product-reveal').each(function(){
            $(this).removeClass('advent-toggle-animation');
        });
    });

    const scene = new ScrollMagic.Scene({
        triggerElement: '#advent-sticky',
        duration: (frameCount * 50) + 'px',
        offset: -400,
        reverse: true
    })
        .setTween(tween)
        .addTo(controller);

    const scene2 = new ScrollMagic.Scene({
        triggerElement: '#advent-sticky',
        duration: (frameCount * 50) + 'px',
        reverse: true
    })
        .setPin('#advent-sticky')
        .addTo(controller);
};

const adventHeroBlock = (el) => {
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];
    const $heading = $('.heading-h3', el);
    const $headline = $('.headline', el);
    const $btn = $('.btn', el);
    const $scrollIndicator = $('.scroll-icon', el);
    const $adventOverlay = $('.advent-banner-overlay', el);

    $(document).ready(function() {
        gsap.to($heading, {transform:'translateY(0)', delay: 1.5, ease: Power4.easeOut});
        gsap.to($heading, {opacity: 1, delay: 1.5});
        gsap.to($headline, {transform:'translateY(0)', delay: 2, ease: Power4.easeOut});
        gsap.to($headline, {opacity: 1, delay: 2});
        gsap.to($btn, {transform:'translateY(0)', delay: 2.5, ease: Power4.easeOut});
        gsap.to($btn, {opacity: 1, delay: 2.5});
        gsap.to($scrollIndicator, {opacity: 1, delay: 3});
        gsap.to($adventOverlay, {opacity: 1, delay: 1.5});
    });

    const controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onEnter'
        }
    });

    const controller2 = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onLeave'
        }
    });

    setTimeout(function(){
        const closingTween = gsap.timeline()
            .add([
                gsap.fromTo($heading, 1, {opacity: 1}, {opacity: 0, ease: 'none'}),
                gsap.fromTo($headline, 1, {opacity: 1}, {opacity: 0, delay: 0.3, ease: 'none'}),
                gsap.fromTo($btn, 1, {opacity: 1}, {opacity: 0, delay: 0.6, ease: 'none'}),
                gsap.fromTo($scrollIndicator, 1, {opacity: 1}, {opacity: 0, delay: 0.9, ease: 'none'})
            ]);

        const scene = new ScrollMagic.Scene({
            triggerElement: $scrollMagicEl,
            duration: '50%'
        })
            .setTween(closingTween)
            .addTo(controller2);
    }, 3000);

    const scene2 = new ScrollMagic.Scene({
        triggerElement: '.js-video-holder',
        duration: '90%'
    })
        .setPin('.js-video-holder')
        .addTo(controller2);

    $(el).addClass('initialized');
};

const adventTextAnimation = (el) => {
    $('.scroll-to-top-link').css('display', 'none');

    const slider = document.querySelector('.js-menu-list-advent');
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        $('.advent-horizontal-menu').css('cursor', 'grabbing');
    });

    slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
        $('.advent-horizontal-menu').css('cursor', 'grab');
    });

    slider.addEventListener('mousemove', (e) => {
        if (!isDown) {
            return;
        }

        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX);
        slider.scrollLeft = scrollLeft - walk;
    });

    const controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onEnter'
        }
    });
    const controller2 = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onLeave'
        }
    });

    const closingTween = gsap.timeline()
        .add([
            gsap.fromTo($('.advent-navigation-dots'), 0.2, {opacity: 0}, {opacity: 1, ease: 'none'}),
            gsap.fromTo($('.advent-horizontal-menu'), 0.2, {opacity: 0}, {opacity: 1, ease: 'none'}),
            gsap.fromTo($('.advent-menu-item'), 0.2, {transform: 'translateY(20px)', opacity: 0}, {transform: 'translateY(0)', opacity: 1, stagger: 0.1, ease: 'none'}),
            gsap.fromTo($('.advent-navigation-dot'), 0.2, {transform: 'translateX(10px)', opacity: 0}, {transform: 'translateX(0)', opacity: 1, stagger: 0.1, ease: 'none'})
        ]);

    const scene = new ScrollMagic.Scene({
        triggerElement: '.js-advent-split',
        offset: 100
    })
        .setTween(closingTween)
        .on('enter', function(){
            $('.advent-navigation-dots').removeClass('advent-navigation-hidden');
            $('.advent-horizontal-menu').removeClass('advent-navigation-hidden');
        })
        .on('leave', function(){
            $('.advent-horizontal-menu').addClass('advent-navigation-hidden');
            $('.advent-navigation-dots').addClass('advent-navigation-hidden');
        })
        .addTo(controller);

    const hideNavigation = gsap.timeline()
        .add([
            gsap.to($('.advent-horizontal-menu'), {opacity: 0, ease: 'none'}),
            gsap.to($('.advent-navigation-dots'), {opacity: 0, ease: 'none'})
        ]);

    const scene2 = new ScrollMagic.Scene({
        triggerElement: '.simple-text-block',
        offset: 0
    })
        .setTween(hideNavigation)
        .on('enter', function () {
            $('.advent-horizontal-menu').addClass('advent-navigation-hidden');
            $('.advent-navigation-dots').addClass('advent-navigation-hidden');
        })
        .on('leave', function () {
            $('.advent-horizontal-menu').removeClass('advent-navigation-hidden');
            $('.advent-navigation-dots').removeClass('advent-navigation-hidden');
        })
        .addTo(controller);

    const scrollToSection = (el) => {
        $('html, body').stop().animate({
            scrollTop: $(el).offset().top
        }, 1600, 'easeOutQuart');
    };

    $('.js-advent-dots').on('click', function(el) {
        const clickedSection = el.target.classList[1];
        scrollToSection($(`[data-adventsection="${clickedSection}"]`));
    });

    $('.js-advent-menu-item').on('click', function(el) {
        const clickedSection = el.target.classList[1];
        scrollToSection($(`[data-adventsection="${clickedSection}"]`));
    });

    $(el).addClass('initialized');
};

/**
 * Initialised the Candle Holder animation
 * @param {DOM Object} el The element to initialise
 */
const initCandleHolderAnimation = (el) => {
    const $first = $('.first', el);
    const $second = $('.second', el);
    const $fourth = $('.fourth', el);
    const $fifth = $('.fifth', el);
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];

    const duration = '65%';
    const offset = -200;

    const controller = new ScrollMagic.Controller();
    const tween = gsap.timeline()
        .add([
            gsap.fromTo($first, 0.7, {xPercent: -50}, {xPercent: -110}),
            gsap.fromTo($second, 0.7, {xPercent: -50}, {xPercent: -80}),
            gsap.fromTo($fourth, 0.7, {xPercent: -50}, {xPercent: -20}),
            gsap.fromTo($fifth, 0.7, {xPercent: -50}, {xPercent: 10})
        ]);

    new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: duration,
        offset: offset
    })
        .setTween(tween)
        .addTo(controller);

    $(el).addClass('initialized');
};

/**
 * Initialised the Easter Egg Gift Set animation
 * @param {DOM Object} el The element to initialise
 */
const initEasterEggGiftSetAnimation = (el) => {
    const controller = new ScrollMagic.Controller();
    const $tiles = $('.js-easter-egg-tile', el);
    const offset = isSmallView() ? -200 : -300;

    $tiles.each((i, tile) => {
        const tileTweens = getTileTweens(i, tile);
        const tileTimeline = new gsap.timeline().add(tileTweens);
        const tileScene = new ScrollMagic.Scene({
            triggerElement: tile,
            duration: '100%',
            offset: offset
        })
            .setTween(tileTimeline)
            .addTo(controller);
    });

    $(el).addClass('initialized');
};

/**
 * Initialises the Banner Video animation
 * @param {DOM Object} el The element to initialise
 */
const initBannerVideoAnimation = (el) => {
    const $window = $(window);
    const durationText = isSmallView() ? 350 : 420;
    const widthPercentage = isSmallView() ? '0% 15%' : '0% 13%';
    const $videoEl = $('.js-video-holder', el);
    const $textContainer = $('.js-text-holder');
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];
    const $hiddenContentTop = $('.js-hidden-content.top');

    const textHolderHeight = $textContainer.outerHeight();
    const videoHeight = $videoEl.outerHeight();
    const visibleContentHeight = $hiddenContentTop.prev('.visible-content').outerHeight();
    const headerHeight = $('.js-header').outerHeight();

    const secondTrigger = '.js-second-scroll-magic-trigger';
    const duration = '40%';

    // place the trigger on the middle of the video since the animation should start when the video is covering the screen
    $(secondTrigger).css('top', $videoEl.offset().top + videoHeight / 2);
    $hiddenContentTop.css('margin-top', -(visibleContentHeight));

    $window.on('scroll', function() {
        if ($window.scrollTop() > textHolderHeight / 2) {
            $textContainer.addClass('visible');
        } else {
            $textContainer.removeClass('visible');
        }
    });

    const controller = new ScrollMagic.Controller();

    // animations for the text content
    const topMargin = ($window.innerHeight() / 2) - (textHolderHeight / 2) - $textContainer.offset().top - 25;
    const tweenTextMargin = gsap.timeline()
        .add([
            gsap.to($textContainer, 1, {margin: topMargin + ' 0 0 0', duration: 0.3, ease: 'none'})
        ]);

    const moveText = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: duration
    })
        .setTween(tweenTextMargin)
        .addTo(controller);

    const pinText = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: durationText,
        offset: 0
    })
        .setPin('.js-text-holder', {pushFollowers: false})
        .addTo(controller);

    const tweenVideoDimensions = gsap.timeline()
        .add([
            gsap.fromTo($videoEl, 1, {'clip-path':'inset(' + widthPercentage + ')'}, {'clip-path':'inset(0% 0%)'})
        ]);

    const resizeVideo = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: duration,
        offset: 0
    })
        .setTween(tweenVideoDimensions)
        .addTo(controller);
};

/**
 * Calculates and returns an array of tile part tweens
 * @param {Number} idx The index of the element to initialise
 * @param {DOM Object} el The element to initialise
 * @returns {Array}
 */
const getTileTweens = (idx, el) => {
    const $parts = $('.js-easter-egg-top, .js-easter-egg-ribbon', el);
    const tileTweens = [];

    $parts.each((i, part) => {
        const $part = $(part);
        const isEgg = $part.hasClass('js-easter-egg-top');
        const duration = isEgg ? 0.8 : 1.8;
        const delay = (isEgg && !isSmallView()) ? (idx * 0.2) : 0;
        const dists = $part.data('travel-dist').split('|');
        const dist = isSmallView() ? parseInt(dists[1]) : parseInt(dists[0]);

        tileTweens.push(
            gsap.fromTo($part, duration, {y: 0}, {y: dist, ease: 'easeInOut', delay: delay})
        );
    });

    return tileTweens;
};

/**
 * Prepares the desktop or mobile images inside an element
 * @param {DOM Object} el The element to prepare the images in
 */
const prepareImages = (el) => {
    $('img', el).each((i, image) => {
        let src;

        // In case of DAM image we need to grab a different data attribute.
        if (typeof $(image).data('src') !== 'undefined') {
            src = $(image).data('src');
        } else {
            src = (isSmallView()) ? $(image).data('mobile-img') : $(image).data('desktop-img');
        }

        $(image).attr('src', src);
    });
};

/**
 * Checks for the presents of a styleguide selector
 * @returns {Boolean}
 */
const isStyleGuide = () => $(scrollEl).parents('.js-alternative-code-example').length > 0;

/**
 * Check if we should init or not by searching for a selector and also making sure it's not initialized in the Styleguide's hidden code
 * @returns {Boolean}
 */
const shouldInit = () => $(scrollEl).length > 0 && !isStyleGuide();

const scrollAnimation = {
    init: () => {
        if (shouldInit()) {
            initAnimations();
        }
    }
};

module.exports = scrollAnimation;
